import { createSlice, PayloadAction } from '@reduxjs/toolkit'
/* eslint no-param-reassign: 0 */

import { getTariffParams } from '../model/tariff.model'

import { Tariff } from '~/basket/model/lines/tariff/tariff.model'

interface ErrorInterface {
  errorCode: number
  errorMessage: string
  id: string
}

interface SelectedTariff {
  id: string
  selectedTariffId: string
}

interface FetchTariffs {
  id: string
  params: getTariffParams
}

interface SuccessTariffList {
  tariffs: Tariff[]
  id: string
}

export type TariffState = {
  [key: string]: SingleTariffCollection
}

interface SingleTariffCollection {
  tariffList: {
    errorCode: number
    errorMessage: string
    data: Tariff[]
  }
  loading: boolean | null
  selectedTariffId: string
}

const tariffStructure: SingleTariffCollection = {
  tariffList: {
    data: [],
    errorMessage: '',
    errorCode: 0,
  },
  selectedTariffId: '',
  loading: false,
}

export const initialState: TariffState = {
  mainLine: tariffStructure,
}

export const tariffSlice = createSlice({
  name: 'tariff',
  initialState,
  reducers: {
    fetchTariffs: (state, action: PayloadAction<FetchTariffs>) => {
      const {
        payload: { id },
      } = action
      return { ...state, [id]: { ...tariffStructure, loading: true } }
    },
    fetchTariffsSuccess(state, action: PayloadAction<SuccessTariffList>) {
      const {
        payload: { id, tariffs },
      } = action
      return {
        ...state,
        [id]: {
          ...tariffStructure,
          tariffList: { ...tariffStructure.tariffList, data: tariffs },
        },
      }
    },
    fetchTariffsError(state, action: PayloadAction<ErrorInterface>) {
      const {
        payload: { errorCode, errorMessage, id },
      } = action
      return {
        ...state,
        [id]: {
          ...tariffStructure,
          tariffList: {
            ...tariffStructure.tariffList,
            errorCode,
            errorMessage,
          },
        },
      }
    },
    setSelectedTariff(state, action: PayloadAction<SelectedTariff>) {
      const {
        payload: { id, selectedTariffId },
      } = action

      return {
        ...state,
        [id]: {
          ...state[id],
          selectedTariffId,
        },
      }
    },
    resetTariffs() {
      return initialState
    },
    deleteTariff: (state, action: PayloadAction<string>) => {
      const { payload } = action
      delete state[payload]
      return state
    },
  },
})

export const {
  fetchTariffs,
  fetchTariffsSuccess,
  fetchTariffsError,
  setSelectedTariff,
  resetTariffs,
  deleteTariff,
} = tariffSlice.actions

const tariffReducer = tariffSlice.reducer
export default tariffReducer
